import React from 'react';
import { FieldRenderer } from '../fieldRegistry';
import { ImageField } from './ImageField';
import { MediaFile } from '../types';

export const renderImageField: FieldRenderer = (
  field,
  formState,
  updateFormState,
  context
) => {
  const mediaFile = formState[field.name] as MediaFile | null;

  return (
    <ImageField
      key={field.name}
      imageUrl={mediaFile?.mediaUrl || mediaFile?.url}
      cardId={context?.cardId}
      slotKey={field.name}
      onImageSelect={(file: MediaFile) => {
        updateFormState(prev => ({
          ...prev,
          [field.name]: file
        }));
      }}
    />
  );
};
